import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-ask-for-confirmation',
    templateUrl: './ask-for-confirmation.component.html',
    styleUrls: ['./ask-for-confirmation.component.css']
})
export class AskForConfirmationComponent implements OnInit {
    @Input() title: string;
    @Input() text: string;
    @Input() btnOKLabel: string = 'Conferma';
    @Input() btnKOLabel: string = 'Annulla';

    constructor(public activeModal: NgbActiveModal) {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ask-for-confirmation/ask-for-confirmation.component.ts